// Clean-ups for the Markdown in API descriptions (info and tags), applied before Redoc renders.
// The swaggers were written for the old portal's renderer; Redoc's (marked) reads two patterns
// differently, which mangled the pages:
//
// - A "---" or "===" line written straight under text is a heading underline, not a divider, so
//   whole intro paragraphs (e.g. i-bank ERP Sandbox) became left-menu titles. In every swagger
//   we have, the authors meant a divider; a blank line before it makes it one.
// - A tab after a list number ("1.<TAB>Create new users") does not start a list, so nested
//   lists (e.g. Bill Payments "Functionality at a glance") ran together into one paragraph.
//   125 of our swaggers have it; a space instead makes them proper lists.
const UNDERLINE = /^ {0,3}(-{3,}|={3,})[ \t]*$/;
const LIST_MARKER_TAB = /^( {0,3}(?:\d{1,3}[.)]|[-*+]))\t+/;
const FENCE = /^ {0,3}(```|~~~)/;

const fixMarkdown = (markdown) => {
  if (typeof markdown !== "string" || !markdown.includes("\n")) return markdown;
  const out = [];
  let inFence = false;
  for (const rawLine of markdown.split("\n")) {
    let line = rawLine;
    if (FENCE.test(line)) inFence = !inFence;
    if (!inFence) {
      if (
        UNDERLINE.test(line) &&
        out.length &&
        out[out.length - 1].trim() !== ""
      ) {
        out.push("");
      }
      line = line.replace(LIST_MARKER_TAB, "$1 ");
    }
    out.push(line);
  }
  return out.join("\n");
};

// Copy of the spec with the description Markdown fixed in info and tags. The spec passed in is
// left untouched.
export const withMarkdownFixes = (spec) => {
  if (!spec || typeof spec !== "object") return spec;
  const result = { ...spec };
  if (spec.info && typeof spec.info.description === "string") {
    result.info = {
      ...spec.info,
      description: fixMarkdown(spec.info.description),
    };
  }
  if (Array.isArray(spec.tags)) {
    result.tags = spec.tags.map((tag) =>
      tag && typeof tag.description === "string"
        ? { ...tag, description: fixMarkdown(tag.description) }
        : tag
    );
  }
  return result;
};
